<template>

    <div class="group/icon relative flex flex-col items-center">
        <i :class="[icon]"></i>
        <span v-if="tooltip"
            class="group-hover/icon:flex z-20 hidden rounded-md flex-col items-center text-sm text-center border-2 p-2 border-sn-orange bg-white absolute bottom-[calc(100%+12px)]"
            :class="{'min-w-32': wide}"
        >
            <span class="text-sn-black" v-text="tooltip"></span>
            <span class="arrow-down-border absolute top-full"></span>
            <span class="arrow-down absolute top-full"></span>
        </span>
    </div>

</template>

<style scoped>

.arrow-down {
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid white;
}
.arrow-down-border {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #FF9E18;
}

</style>

<script setup lang="ts">

const props = defineProps({
    icon: {
        type: String,
        required: true,
    },
    tooltip: {
        type: String,
        required: false,
    },
    wide: {
        type: Boolean,
        default: false,
    }
})

</script>